import type { DashboardRole } from "@/types/dashboard";

const CLIENT_METRIC_LABELS: Record<string, string> = {
  "Total Tasks": "Total Tasks",
  "In Progress": "On-going",
  Completed: "Closed",
  Pending: "Open Ticket",
};

const CLIENT_STATUS_LABELS: Record<string, string> = {
  Pending: "Open Ticket",
  "In Progress": "On-going",
  "In-Progress": "On-going",
  Completed: "Closed",
};

export function isClientDashboardRole(role?: DashboardRole | string | null) {
  return String(role || "").toLowerCase() === "client";
}

export function getDashboardMetricLabel(
  label: string,
  role?: DashboardRole | string | null,
) {
  if (!isClientDashboardRole(role)) return label;
  return CLIENT_METRIC_LABELS[label] || label;
}

export function getDashboardStatusLabel(
  status: string,
  role?: DashboardRole | string | null,
) {
  if (!isClientDashboardRole(role)) return status;
  return CLIENT_STATUS_LABELS[status] || status;
}
